import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Container, Modal, Button } from "react-bootstrap";
import { Steps } from "antd";
import { ConfirmDetails } from "./confirmdetails/ConfirmDetails";
import { PaymentDetails } from "./paymentdetails/PaymentDetails";
import { CheckAvailability } from "./checkavailability/CheckAvailability";
import { Routes, useNavigate } from "react-router-dom";
import { Routers } from "../../routes/Constant";
import { LeftArrow } from "../../assets/icons/LeftArrow";
import { SelectPackBox } from "./selectpackbox/SelectPackBox";
import { Route } from "react-router-dom";
import { useNavigation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef } from "react";
import CalenderSlice, { getData } from "../../redux/slice/CalenderSlice";
import { InstructorBookingById } from "../../redux/slice/authSlice";
import { objectFiledDataStart } from "../../redux/slice/objectSlice";
import tick from "../../assets/images/Tick.png";
import "./Progress.css";
import Spinner from "react-bootstrap/Spinner";
import defaultImage from "../../assets/images/default-image.png";

export const Progress = () => {
  const { state } = useLocation();
  const selectedPackages = state?.selectedPackages || [];
  const dispatch = useDispatch();
  const [calender, setCalender] = useState([]);
  const [current, setCurrent] = useState(0);

  const { instructorsdetails } = useSelector((state) => state?.instructors);

  const { instructorBooking } = useSelector((state) => state?.auth);
  const packageDataById =
    instructorsdetails?.length > 0 ? instructorsdetails[0]?.data?.id : "";
  const instructorName =
    instructorsdetails?.length > 0 ? instructorsdetails[0]?.data?.name : "";
      const instructorProfileImage =
    instructorsdetails?.length > 0 ? instructorsdetails[0]?.data?.profile_image : "";
  const [timeDurationPackage, setTimeDurationPackage] = useState("");
  const [lessonCount, setLessonCount] = useState("");
  const [tokenGet, setTokenGet] = useState("");
  const [bookDone, setBookDone] = useState(false);
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [isPayment, setIsPayment] = useState(false);
  // const yourObjectData = useSelector((state) => state?.objectReducer?.yourObject);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    if (instructorBooking) {
      setMessage(instructorBooking?.message);
    }
  }, [instructorBooking]);

  const storedData = JSON.parse(localStorage.getItem("bookingData"));

  const selectedPackage = selectedPackages?.[0] || {};

  console.log(selectedPackage);

const [bookingData, setBookingData] = useState(() => {
  const stored = localStorage.getItem("bookingData");

  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (error) {
      console.error("Failed to parse bookingData from localStorage:", error);
    }
  }

  return {
    instructor_id: packageDataById ?? null,
    learner_id: null,
    start_date: selectedPackage.start_date || "",
    end_date: selectedPackage.end_date || "",
    name_instructor: instructorName || "",
    pickup_location: "",
    city: "",
    postal_code: "",
    packageDuration: selectedPackage.duration || "",
    payment_type: "",
    lesson_count: selectedPackage.lesson_count || "",
    amount: selectedPackage.amount ?? undefined,
    ...(selectedPackage.package_id && { package_id: selectedPackage.package_id }),
  };
});



  const updateFieldData = (field, value) => {
    setBookingData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const tokenGetter = (value) => {
    if (value) {
      bookingData["token"] = value;
    }
  };

  useEffect(() => {
    const storedCount = parseInt(window.localStorage.getItem("count"));
    if (selectedPackages.length > 0) {
      setCurrent(storedCount || 1);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("bookingData", JSON.stringify(bookingData));
  }, [bookingData]);

  useEffect(() => {
    window.localStorage.setItem("count", current);
    const jsonString = JSON.stringify(bookingData);
    window.localStorage.setItem("bookingData", jsonString);
  }, [current]);

  const SelectPacknext = () => {
    setCurrent(current + 1);

    setTimeDurationPackage(bookingData.packageDuration);
  };

  // const isFirstRender = useRef(true);

  const FinalPayment = () => {
    setIsPayment(true);

    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    try {
      tokenGetter();
      dispatch(InstructorBookingById(bookingData));
      setBookDone(true);
      localStorage.setItem("count", "0");
      localStorage.removeItem("bookingData");
      setBookingData({
        instructor_id: packageDataById,
        learner_id: null,
        start_date: selectedPackages?.[0]?.start_date || [],
        end_date: selectedPackages?.[0]?.end_date || [],
        name_instructor: instructorName,
        pickup_location: "",
        city: "",
        postal_code: "",
        packageDuration: selectedPackages?.[0]?.duration || "",
        payment_type: "",
        amount: selectedPackages?.[0]?.amount || undefined,
        ...(selectedPackages?.[0]?.package_id
          ? { package_id: selectedPackages[0].package_id }
          : {}),
      });
      // handleShowModal();
      if (message) {
        setMessage(false);
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (instructorBooking && bookDone) {
      setMessage(instructorBooking?.message);
      handleShowModal(); // ✅ Now safe to show
    }
  }, [instructorBooking, bookDone]);

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "Please select lesson pack",
      content: (
        <SelectPackBox
          SelectPacknext={SelectPacknext}
          updateFieldData={updateFieldData}
          bookingData={bookingData}
          selectedPackage={selectedPackage}
        />
      ),
    },
    // ,
    // {
    //   title: "Check Availability",
    //   content: (
    //     <CheckAvailability
    //       SelectPacknext={SelectPacknext}
    //       updateFieldData={updateFieldData}
    //       timeDurationPackage={timeDurationPackage}
    //       bookingData={bookingData}
    //     />
    //   ),
    // }
    {
      title: "Confirm Details",
      content: (
        <ConfirmDetails
          SelectPacknext={SelectPacknext}
          updateFieldData={updateFieldData}
          bookingData={bookingData}
        />
      ),
    },
    {
      title: "Payment Details",
      content: (
        <PaymentDetails
          SelectPacknext={FinalPayment}
          tokenGetter={tokenGetter}
          bookingData={bookingData}
          updateFieldData={updateFieldData}
        />
      ),
    },
  ];

  const items = steps.map((item) => ({
    key: <div>{item.title}</div>,
    title: <div>{item.title}</div>,
  }));

  const [showModal, setShowModal] = useState(false); // State to control the modal visibility

  // Function to show the modal
  const handleShowModal = () => {
    setShowModal(true);
  };

  // Function to hide the modal
  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
  <section className="progress_bar_sec">
    <div className="progress_handle bg-grey">
      <div className=" progress_sec d-flex">
        <div
          className={`back_icon d-flex align-items-center justify-content-between  ${
            current === 0 ? "col-0" : "col-lg-2"
          }`}
        >
          <div>
            {current >= 1 && (
              <Link
                onClick={() => prev()}
                className="back_sec text-light-black d-flex align-items-center"
              >
                <LeftArrow />
                Back
              </Link>
            )}
          </div>
        </div>
        <div className={`stepper ${current === 0 ? "col-12" : "col-lg-10"}`}>
          <Steps
            current={current}
            items={items}
            labelPlacement="vertical"
            responsive={false}
          />
        </div>
      </div>
    </div>

    <div className="profile-card">
      <div className="img-wrapper">
        <img
          src={
            instructorProfileImage
              ? "https://keyzi.com.au/keyzi-admin/public/" + instructorProfileImage
              : defaultImage
          }
          alt="profile"
        />
        <h5>{instructorName}</h5>
        <h6>Instructor</h6>
      </div>
    </div>

    <div>
      {isPayment ? (
        instructorBooking && bookDone ? (
          <div className="payment_done_section text-center pt-5 pb-5">
            <img src={tick} alt="Booked" height="120px" width="120px" />
            <p className="booking_msg mt-3">{message}</p>
            <Link
              className="text-indigo bookPyament_btn_dashboard"
              to={`/xcsfvt/auth/dashboard/booking/booking-details/${instructorBooking?.booking_id}`}
            >
              Go To Booking Detail
            </Link>
          </div>
        ) : (
          <div className="progress_spinner_wrapper spinner-container d-flex justify-content-center flex-column">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
              Please wait while we process your request. This may take a few
                moments. Do not refresh the page or close your browser.
          </div>
        )
      ) : (
        <div>{steps[current]?.content}</div>
      )}
    </div>
  </section>
</>

  );
};
